import { render, staticRenderFns } from "./WdfBasicInput.vue?vue&type=template&id=09b3dd50&scoped=true"
import script from "./WdfBasicInput.vue?vue&type=script&lang=js"
export * from "./WdfBasicInput.vue?vue&type=script&lang=js"
import style0 from "./WdfBasicInput.vue?vue&type=style&index=0&id=09b3dd50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3dd50",
  null
  
)

export default component.exports